import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { DOMAIN_CONFIGS } from '../config';

const DomainSwitcher = () => {
  const { domainConfig, switchDomain, isDevelopment } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  // Only show in development mode
  if (!isDevelopment) {
    return null;
  }

  const handleDomainSwitch = (domainId) => {
    switchDomain(domainId);
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-primary text-white px-4 py-2 rounded-lg shadow-lg hover:bg-primary-dark transition-colors"
        >
          Switch Domain ({domainConfig?.id})
        </button>
        
        {isOpen && (
          <div className="absolute bottom-full right-0 mb-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 max-h-96 overflow-y-auto">
            <div className="p-2">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Available Domains
              </div>
              {Object.entries(DOMAIN_CONFIGS).map(([hostname, config]) => (
                <button
                  key={config.id}
                  onClick={() => handleDomainSwitch(config.id)}
                  className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${
                    domainConfig?.id === config.id
                      ? 'bg-primary text-white'
                      : 'hover:bg-gray-100 text-gray-700'
                  }`}
                >
                  <div className="font-medium">{config.name}</div>
                  <div className="text-xs opacity-75">{hostname}</div>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DomainSwitcher;
